class AccordionComponent extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', event => {
        this.onAccordionClick(event);
      });
    }

    onAccordionClick(event) {
      const { target } = event;

      if(target.tagName == 'H4') {
        if(target.classList.contains('open')) {
          target.classList.remove('open')
        } else {
          this.querySelectorAll('h4').forEach(el => {
            el.classList.toggle('open', el == target);
          });
        }
      }
    }
  }

  customElements.define('accordion-component', AccordionComponent);
